/** Affiliate portal paths, so no screen hard-codes a route string. */
export const AFFILIATE_ROUTES = {
  LANDING: '/affiliate',
  SIGN_IN: '/affiliate/signin',
  SIGN_UP: '/affiliate/signup',
  DASHBOARD: '/affiliate/dashboard',
  PROFILE: '/affiliate/profile',
} as const;
